import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
// import { NotificationsService } from 'angular2-notifications';
import { BaseDataService, BaseInlineUpdateComponent, InlineContainerService, NotificationService } from 'yt-ng-framework';
import { UserIPAddress } from './useripaddress';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-useripadress-inline-update',
  templateUrl: './useripadress-inline-update.component.html'
})
export class UseripadressInlineUpdateComponent extends BaseInlineUpdateComponent<UserIPAddress> {

  constructor(protected inlineContainerService: InlineContainerService<UserIPAddress>,
              protected baseDataService: BaseDataService,
              // protected notificationsService: NotificationsService,
              protected toastrService: NotificationService){
    super(inlineContainerService);
  }

  @Output() ItemSaved: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('baseUpdate', { static: true }) baseUpdate: any;
  
    Save(){

    let parameters = { UserId: this.baseUpdateComponent.Item.ID, IPAddress: this.baseUpdateComponent.baseFormGroup.get('IPAddress').value};
    this.baseDataService.Post('User', 'UpdateIPAddress', parameters, UserIPAddress)
      .subscribe((item)=>{ 
        this.ItemSaved.emit(true);
        // this.notificationsService.success('Uspešno', 'Sačuvan');
        this.toastrService.success('Uspešno', 'Sačuvan');
        this.baseUpdate.SavedItem.IPAddress = item[0].IPAddress;
      });
  }

}
